import type SOURCE_TYPE from '@/features/SourceCreate/SourceCreate.constants';

/**
 * Builds cloud sources filter URL with query parameters
 *
 * Creates a URL for filtering cloud sources by source type ID.
 * The query parameters are JSON-encoded for consistent parsing.
 *
 * @param sourceTypeId - Source type ID from SOURCE_TYPE enum
 * @returns Formatted URL with encoded query parameter
 *
 * @example
 * ```tsx
 * const url = buildCloudSourcesFilterUrl(SOURCE_TYPE.AWS_CLOUDTRAIL);
 * // Returns: "/devices/cloud-sources?q={\"source_type_id\":\"9\"}"
 * ```
 */
export const buildCloudSourcesFilterUrl = (
  sourceTypeId: SOURCE_TYPE
): string => {
  return `/devices/cloud-sources?q=${JSON.stringify({
    source_type_id: sourceTypeId.toString()
  })}`;
};
